import styled from 'styled-components';

import { color } from 'styles/utils';

import chevron from '../../images/icons/chevron-down.svg';

const FormControl = styled.input`
  border-radius: 0.25rem;
  color: ${color('text.base')};
  flex: 0 1 auto;
  font-size: inherit;
  min-width: 0;
  padding: 0.75rem 1rem;
  text-overflow: ellipsis;

  ::placeholder {
    color: inherit;
    opacity: 1;
  }

  [data-invalid] &:invalid {
    outline: 2px solid ${color('red')};
  }

  &:where(select) {
    appearance: none;
    background: white url(${chevron}) no-repeat top 50% right 1em / 0.75em;
    padding-right: 3rem;
  }
`;

export default FormControl;
